export const mixpanelProjectToken = '79bca8ae2d79ca239c0605e5a8834b8d'